import axiosInstance from './axios-instance';

interface UploadFileParams {
  rawFile: File;
  isPrivate?: boolean;
}

export const uploadFilePost = async ({
  rawFile,
  isPrivate = false
}: UploadFileParams) => {
  try {
    const formData = new FormData();
    formData.append('file', rawFile);
    formData.append('isPrivate', String(isPrivate));

    const response = await axiosInstance.post(`/media-library/file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    return response.data.path;
  } catch (error) {
    void error;
    throw error;
  }
};

export const getUploadFileUrl = async ({ filename }: { filename: string }) => {
  const response = await axiosInstance.get(
    `/media-library/file/get-upload-url`,
    {
      params: { filename }
    }
  );

  return response.data;
};

export const createMedia = async (body: any) => {
  const response = await axiosInstance.post(
    '/media-library/media-library',
    body
  );
  return response.data;
};

export const getAboutFileInfo = async (path: string) => {
  const response = await axiosInstance.get(
    `/media-library/media-library/path/${path}`
  );

  return response.data;
};

export const getDownloadFileUrl = async (filePath: string) => {
  const response = await axiosInstance.get(
    `/media-library/file/get-download-url`,
    {
      params: { filePath }
    }
  );

  return response.data;
};
